import { dashMetaFetch } from '../../../shared/api/dash-meta-fetch';
import {
  parseRetryAfterSeconds,
  SharedReportRateLimitError,
} from './dash-meta-rate-limit-error';

interface CreateSharedReportPayload {
  name: string;
  pageConfig: Record<string, unknown>;
  chartData: Record<string, unknown>;
  pageState: Record<string, unknown>;
}

interface CreateSharedReportResponse {
  token: string;
}

export interface SharedReportSnapshot {
  token: string;
  name: string;
  pageConfig: Record<string, unknown>;
  chartData: Record<string, unknown>;
  pageState: Record<string, unknown>;
  created: string;
}

export const createSharedReport = async (
  payload: CreateSharedReportPayload
): Promise<CreateSharedReportResponse> => {
  const response = await dashMetaFetch('/api/shared-reports', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  if (response.status === 429) {
    throw new SharedReportRateLimitError(parseRetryAfterSeconds(response));
  }

  if (!response.ok) {
    throw new Error('Failed to create shared report');
  }

  return response.json();
};

export const getSharedReport = async (
  token: string
): Promise<SharedReportSnapshot> => {
  const response = await dashMetaFetch(`/api/shared-reports/${token}`);

  if (!response.ok) {
    throw new Error('Shared report not found');
  }

  return response.json();
};
